import { ApiCtx, call, Next } from "starfx";

import { getWorker } from "./gxworker-factory";

export function* mainWorker(ctx, next) {
  const gxWorker = getWorker();
  const pxWorker = getWorker();

  const { url, ...options } = ctx.req();
  const params = new URLSearchParams(url);

  switch (options.method) {
    case "GET":
      {
        const message = JSON.stringify({
          type: "GET",
          url,
          options: {
            params: params.toString(),
            meta: { key: ctx.key },
          },
        });
        if (url.startsWith("/px/")) {
          yield* call(() => pxWorker.postMessage(message));
        } else {
          yield* call(() => gxWorker.postMessage(message));
        }
      }
      break;
    case "DELETE":
    case "PUT":
    case "POST": {
      const body = JSON.parse(options.body as string);
      const message = JSON.stringify({
        type: options.method,
        url,
        options: { data: body, meta: { key: ctx.key } },
      });
      try {
        if (url.startsWith("/px/")) {
          yield* call(() => pxWorker.postMessage(message));
        } else {
          yield* call(() => gxWorker.postMessage(message));
        }
      } catch (e) {
        console.error("gxWorker.postMessage error", e);
      }
      break;
    }
    default:
      break;
  }
  yield* next();
}
